import React, { useContext, useState } from 'react';
import { Button, DatePicker, Form, Modal, Space, message } from 'antd';
import dayjs from 'dayjs';
import moment from 'moment';
import useService from '@/lib/hooks/useService';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import { ReservationContext } from '../UpdateProcessButtonWithModal';
import { UpdateReservationsContext } from '../TodayReservations';
import styles from './index.module.scss';
import type { CarServiceReservation } from '@/types/database/carService';

dayjs.extend(advancedFormat);

const UpdateProcessArrivalButtonWithModal = () => {
  const { key: reservationId, reservationTime } =
    useContext(ReservationContext);
  const updateData = useContext(UpdateReservationsContext);

  const [form] = Form.useForm();

  const [, , carService] = useService<CarServiceReservation>({
    collectionName: 'carService',
  });

  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  const closeArrivalFormModal = () => {
    form.resetFields();
    setIsOpenModal(false);
  };

  const handleFormSubmit = (values: { actualArrivalTime: string }) => {
    const actualArrivalTime = Number(
      dayjs(values.actualArrivalTime).format('x')
    );
    carService
      .patch(reservationId, {
        actualArrivalTime,
        status: '已下車',
      })
      .then(() => {
        message.success('資料更新成功!');
        updateData();
      });
  };

  return (
    <>
      <Modal open={isOpenModal} onCancel={closeArrivalFormModal} footer={false}>
        <Form form={form} layout="vertical" onFinish={handleFormSubmit}>
          <Form.Item
            label="實際抵達時間"
            name="actualArrivalTime"
            rules={[{ required: true, message: '請選擇實際抵達時間' }]}
            initialValue={
              reservationTime
                ? moment(reservationTime).startOf('day')
                : moment().startOf('day')
            }
          >
            <DatePicker
              showTime={{ format: 'HH:mm' }}
              format="YYYY-MM-DD HH:mm"
              placeholder="請選擇實際抵達時間"
              inputReadOnly
            />
          </Form.Item>
          <Form.Item>
            <Space className={styles.footerButtons}>
              <Button type="primary" onClick={closeArrivalFormModal}>
                取消
              </Button>
              <Button htmlType="submit">確認</Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
      <Button
        className={styles.stepButton}
        onClick={() => setIsOpenModal(true)}
      >
        新增進度
      </Button>
    </>
  );
};

export default UpdateProcessArrivalButtonWithModal;
